var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGenieOnWork(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 933,
    height: 459,
    viewBox: "0 0 933 459",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2190_18807)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 933,
    height: 459,
    rx: 40,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.891,
    cy: 229.5,
    r: 69.7773,
    fill: "#5F60FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.887,
    cy: 361.519,
    r: 30.8945,
    fill: "#2BC275"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.887,
    cy: 361.52,
    r: 30.8945,
    fill: "#2BC275"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 530.684,
    cy: 413.721,
    r: 30.8945,
    fill: "#2BC275"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 604.457,
    cy: 394.195,
    r: 30.8945,
    fill: "#2BC275"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395.123,
    cy: 143.209,
    r: 26.9004,
    fill: "#D74E26"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395.123,
    cy: 143.209,
    r: 26.9004,
    fill: "#D74E26"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.111,
    cy: 318.374,
    r: 26.9004,
    fill: "#D74E26"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.045,
    cy: 244.15,
    r: 26.9004,
    fill: "#D74E26"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.092,
    cy: 56.918,
    r: 26.9004,
    fill: "#D74E26"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 579.736,
    cy: 197.01,
    r: 26.9004,
    fill: "#D74E26"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 553.592,
    cy: 132.822,
    r: 26.9004,
    fill: "#D74E26"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 499.791,
    cy: 83.8184,
    r: 26.9004,
    fill: "#D74E26"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2190_18807)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 933,
    height: 459,
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 917,
    height: 443,
    stroke: "white",
    strokeWidth: 16
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2190_18807",
    x: -75,
    y: -75,
    width: 1083,
    height: 609,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 37.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2190_18807"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2190_18807",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2190_18807"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 933,
    height: 459,
    rx: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenieOnWork);
export default __webpack_public_path__ + "static/media/genie-on-work.c07e429c0928895ed5e752fdc3bcad64.svg";
export { ForwardRef as ReactComponent };